function Em({ children }) {
  return <span className="font-medium text-slate-600">{children}</span>;
}

/** Help copy shown under the Manage / Analytics / Activity tab switcher. */
function DashboardTabDescription({ activeTab, isSuperadmin }) {
  if (activeTab === 'manage') {
    return (
      <p className="text-sm text-slate-400">
        <Em>Add a venue</Em> — click "+ Add
        Venue" above. <Em>Edit a venue</Em>{' '}
        — click the pencil icon on its card to update its details, including working
        hours. <Em>Select a venue card</Em>{' '}
        to manage its shows. <Em>Add, edit, or
        hide shows</Em> for that venue — including opening hours and images — to
        control what's visible in the Showrunner feed.{' '}
        <Em>Combine shows</Em> when two
        entries are duplicates of the same show — the kept show absorbs the other's views,
        clicks, seen counts, and images, and the duplicate is hidden for good (this can't be
        undone).
        {isSuperadmin && (
          <>
            {' '}<Em>Combine venues</Em> to merge
            one into another — this moves all its shows and archives the original.
          </>
        )}
        {' '}Hidden shows{isSuperadmin ? ' and archived venues' : ''} stay recoverable —
        unhide{isSuperadmin ? ' or unarchive' : ''} anytime to bring them back.
      </p>
    );
  }

  if (activeTab === 'activity') {
    return (
      <p className="text-sm text-slate-400">
        <Em>See every change</Em> made to this
        organization's shows, venues, and profile from the dashboard — who made it, when, and each
        field's old and new value. Only visible to superadmins.
      </p>
    );
  }

  return (
    <p className="text-sm text-slate-400">
      <Em>View total views, clicks, and saves</Em>{' '}
      over time in the chart above. <Em>Views</Em>{' '}
      are how many users saw a show,{' '}
      <Em>Clicks</Em> are users who clicked into a
      show's detail page, and <Em>Seen</Em> are
      users who marked a show as seen (i.e. they've physically been to the show).{' '}
      <Em>Filter by
      venue</Em> to narrow the results to one location.{' '}
      <Em>Adjust the period or granularity</Em>{' '}
      to explore different trends in your audience engagement.{' '}
      <Em>Show Opening markers</Em> mark the
      dates shows opened, so you can see how they line up with your data.{' '}
      <Em>Click a legend item</Em> above the
      chart to toggle it on or off. Views tracking started September 1, 2026, so periods
      before that date won't show Views data — hover near the start of the Views line to
      see the start marker. Shows with no activity in the selected period are not listed
      in the breakdown below.
    </p>
  );
}

export default DashboardTabDescription;
